import React from "react"
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { Check } from "lucide-react"

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

const Checkbox = React.forwardRef(({ className, checked, onCheckedChange, ...props }, ref) => (
    <button
        type="button"
        role="checkbox"
        aria-checked={checked}
        onClick={() => onCheckedChange(!checked)}
        ref={ref}
        className={cn(
            "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
            checked ? "bg-primary text-primary-foreground" : "border-input",
            className
        )}
        {...props}
    >
        {checked && <Check className="h-3 w-3" />}
    </button>
))
Checkbox.displayName = "Checkbox"

export { Checkbox }
